export type ShopStockProduct = {
  idProduct?: number;
  colours?: Array<ShopStockColor>;
};

export type ShopStockColor = {
  colourCode?: string;
  idColour?: number;
  sizes?: Array<ShopStockSize>;
};

export type ShopStockSize = {
  availableStock?: number;
  flagResStock?: boolean;
  flagTbrStock?: boolean;
  idSize?: number;
  idSku?: number;
};

export type StockSkuShop = {
  availableStock?: number;
  flagResStock?: boolean;
  flagTbrStock?: boolean;
  idColour?: number;
  idProduct?: number;
  idShop?: number;
  idSize?: number;
  idSku?: number;
  shopName?: string;
  shopNumber?: string;
};

export type ShopProductColorAvailability = {
  colorId: number;
  colorCode: string;
  description: string;
  swatch: string;
  sizes?: ShopProductColorSkuAvailability;
};

export type ShopProductColorSkuAvailability = {
  [key: string]: ShopStockSize;
};
